module.exports = __webpack_public_path__ + "img/Skirt-Front-B9-Da-Fb-Hc-Ic-Ja.ed93a0ff.png";